import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = () => {
  const location = useLocation();

  const getBreadcrumbItems = () => {
    const pathMap = {
      '/wealth-dashboard': [
        { label: 'Dashboard', path: '/wealth-dashboard', icon: 'LayoutDashboard' }
      ],
      '/income-management': [
        { label: 'Planning', path: null, icon: 'Calculator' },
        { label: 'Income Management', path: '/income-management', icon: 'TrendingUp' }
      ],
      '/expense-tracking': [
        { label: 'Planning', path: null, icon: 'Calculator' },
        { label: 'Expense Tracking', path: '/expense-tracking', icon: 'Receipt' }
      ],
      '/asset-portfolio': [
        { label: 'Planning', path: null, icon: 'Calculator' },
        { label: 'Asset Portfolio', path: '/asset-portfolio', icon: 'PieChart' }
      ],
      '/emergency-fund': [
        { label: 'Planning', path: null, icon: 'Calculator' },
        { label: 'Emergency Fund', path: '/emergency-fund', icon: 'Shield' }
      ],
      '/surplus-routing': [
        { label: 'Planning', path: null, icon: 'Calculator' },
        { label: 'Surplus Routing', path: '/surplus-routing', icon: 'Sliders' }
      ],
      '/drawdown-priority': [
        { label: 'Planning', path: null, icon: 'Calculator' },
        { label: 'Drawdown Priority', path: '/drawdown-priority', icon: 'Shuffle' }
      ],
      '/special-events': [
        { label: 'Planning', path: null, icon: 'Calculator' },
        { label: 'Special Events', path: '/special-events', icon: 'CalendarPlus' }
      ],
      '/debt-liabilities': [
        { label: 'Planning', path: null, icon: 'Calculator' },
        { label: 'Debt & Liabilities', path: '/debt-liabilities', icon: 'CreditCard' }
      ],
      '/investments-allocations': [
        { label: 'Planning', path: null, icon: 'Calculator' },
        { label: 'Investments & Allocations', path: '/investments-allocations', icon: 'Wallet' }
      ],
      '/scenario-planning': [
        { label: 'Analysis', path: '/scenario-planning', icon: 'GitBranch' }
      ],
      '/reports-analytics': [
        { label: 'Reports', path: '/reports-analytics', icon: 'FileText' }
      ]
    };

    return pathMap[location.pathname] || [];
  };

  const breadcrumbItems = getBreadcrumbItems();

  if (breadcrumbItems.length === 0) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
      <Link 
        to="/wealth-dashboard" 
        className="flex items-center gap-1 hover:text-foreground transition-colors duration-200"
      >
        <Icon name="Home" size={16} />
        <span>Home</span>
      </Link>

      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={index}>
          <Icon name="ChevronRight" size={16} className="text-border" />
          
          {item.path ? (
            <Link 
              to={item.path}
              className={`
                flex items-center gap-1 transition-colors duration-200
                ${index === breadcrumbItems.length - 1 
                  ? 'text-foreground font-medium' 
                  : 'hover:text-foreground'
                }
              `}
            >
              <Icon name={item.icon} size={16} />
              <span>{item.label}</span>
            </Link>
          ) : (
            <span className="flex items-center gap-1">
              <Icon name={item.icon} size={16} />
              <span>{item.label}</span>
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;